import { useState, useEffect, useCallback } from 'react';
const mockQuotaStats = {
    configured: false,
    workers: {
        name: 'Workers Requests',
        used: 45000,
        limit: 100000,
        unit: 'requests/day',
        percentage: 45,
        planType: 'free',
        resetPeriod: 'daily',
    },
    pages: {
        name: 'Pages Builds',
        used: 127,
        limit: 500,
        unit: 'builds/month',
        percentage: 25.4,
        planType: 'free',
        resetPeriod: 'monthly',
    },
    r2: {
        name: 'R2 Storage',
        used: 2.4,
        limit: 10,
        unit: 'GB',
        percentage: 24,
        planType: 'free',
    },
    lastUpdated: new Date().toISOString(),
};
export function useQuotaStats() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch('/api/stats/quotas', { credentials: 'include' });
            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`);
            }
            const json = await res.json();
            setData(json);
        }
        catch (err) {
            console.error('Quota stats fetch error:', err);
            setError(err instanceof Error ? err.message : 'Failed to fetch');
            setData(mockQuotaStats);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchData();
        // Refresh every 5 minutes
        const interval = setInterval(fetchData, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, [fetchData]);
    return { data, loading, error, refresh: fetchData };
}
/**
 * Get threshold level based on percentage
 * - success: 0-50% (green)
 * - warn: 50-80% (yellow)
 * - error: 80%+ (red)
 */
export function getThresholdLevel(percentage) {
    if (percentage >= 80)
        return 'error';
    if (percentage >= 50)
        return 'warn';
    return 'success';
}
/**
 * Get CSS color variable for threshold level
 */
export function getThresholdColor(percentage) {
    const level = getThresholdLevel(percentage);
    switch (level) {
        case 'error': return 'var(--error)';
        case 'warn': return 'var(--warn)';
        default: return 'var(--success)';
    }
}
/**
 * Format large numbers for display (e.g., 45000 -> "45K")
 */
export function formatNumber(num) {
    if (num >= 1000000)
        return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000)
        return `${(num / 1000).toFixed(1)}K`;
    return num.toLocaleString();
}
